module.exports = __webpack_public_path__ + "static/media/white_logo.69784a9a.png";